import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { DatatableCompatDirective } from 'src/app/shared/datatables-compat/datatable-compat.module';
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { SprintModel } from "src/app/shared/model/gestion-proyectos/sprint";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { ModalSprintComponent } from "../modal-sprint/modal-sprint.component";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import swal from 'sweetalert2';
import { HistoriaDeUsuario } from "src/app/shared/historiaUsuario";
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDropList, CdkDrag } from "@angular/cdk/drag-drop";
import { SprintBackLog } from "src/app/shared/sprintBackLog.model";
import { EstatusHUCUTASK, EstatusHUCUenum } from "src/app/utilerias/enums/estatusHU-CUEnum";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { NgIf, NgFor } from "@angular/common";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
    selector: 'app-modal-agregar-sprintbacklog',
    templateUrl: './modal-agregar-sprintbacklog.component.html',
    styleUrls: ['./modal-agregar-sprintbacklog.component.css'],
    imports: [MatIconButton, MatIcon, NgIf, CdkScrollable, CdkDropList, NgFor, CdkDrag, MatTooltip, MatButton]
})
export class ModalSprintBacklogComponent implements OnInit{
  mostrarTabla: boolean;
  @ViewChild('scrollElementContentHU')
  scrollElementContentHU: ElementRef<HTMLElement>;
  resourcesDataHistoriasU: Array<HistoriaDeUsuario>;
  resourcesFilterHistoriasU: Array<HistoriaDeUsuario>;
  doneHistoriasU: Array<HistoriaDeUsuario> = [];
  recursosAsignados: HistoriaDeUsuario[];
  objectSprint: SprintModel= new SprintModel();
  huSeleccionada: Array<HistoriaDeUsuario> = [];
  panelEditable: boolean=true;
  estatusSprint: string;

    constructor( private service: ProyectosService, public dialogRef: MatDialogRef<ModalSprintBacklogComponent>, 
      private msg: Msg, @Inject(MAT_DIALOG_DATA) public data: any){}

  
    ngOnInit(){
      this.mostrarTabla =true;
      this.objectSprint = this.data.sprint;
      this.inicializarValores();
      this.consultaHistoriasUsuario();
    }

    inicializarValores(){
      this.estatusSprint=EstatusHUCUTASK.eliminarGuion(this.objectSprint.estatus)
      if (this.objectSprint.huAsignadas.length > 0) {
        const recursos = this.objectSprint.huAsignadas;
        if (recursos) {
          this.doneHistoriasU = recursos;
        }
      }else{
        this.doneHistoriasU = new Array();
      }
      if(this.estatusSprint !== EstatusHUCUenum.PENDIENTE){
       this.panelEditable=false;
      }
    }

    onNoClick(): void {
      this.dialogRef.close();

    }

    consultaHistoriasUsuario(){
      this.service.consultaHUPendientes(this.data.id).subscribe(res =>{
        if(res.list.length !==0){
          this.resourcesDataHistoriasU = res.list;

          this.resourcesFilterHistoriasU  = res.list;
          if (this.doneHistoriasU && this.doneHistoriasU.length > 0) {
            this.doneHistoriasU.forEach(item => {
              const index = this.resourcesFilterHistoriasU.findIndex(
                itemHU => itemHU.id === item.id
              );
              if (index !== -1) {
                this.resourcesFilterHistoriasU.splice(index, 1);
              }            
            });
          }            
        }
      })
    }

    removeAsignados(item: HistoriaDeUsuario) {
        const index = this.doneHistoriasU.indexOf(item);
        if (!this.resourcesFilterHistoriasU) {
          this.resourcesFilterHistoriasU = new Array();
        }
        this.doneHistoriasU.splice(index, Constantes.UNO);
          this.resourcesFilterHistoriasU.push(item);
    }

    dropHistoriasU(event: CdkDragDrop<Array<HistoriaDeUsuario>>) {
      if (event.previousContainer === event.container) {
        moveItemInArray(
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );

      }
    }




    save(){
      // this.objectHU.sprintBackLog = this.sprintBackLog;
      for (let i = 0; i < this.doneHistoriasU.length; i++) {
        this.huSeleccionada[i] = this.doneHistoriasU[i];
      }
      this.objectSprint.huAsignadas= this.huSeleccionada;
      this.service.guardaActualizaSBacklog(this.objectSprint).subscribe(res=>{
        swal.fire({
          title: res.pCodRetorno === '00000' ? 'ÉXITO' : 'ERROR',
          text: res.pMensaje,
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          confirmButtonText: 'Aceptar',
          icon: res.pCodRetorno === '00000' ? 'success' : 'warning'
        }).then(abc => {
            this.dialogRef.close(true);
        });
      })

    }

  
}
